import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { GenericTabViewImpl } from './generictabview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { GenericTabCSSStyleImpl } from './generictabcss';
import { GenericTabViewModel } from './generictabviewmodel';

export interface GenericTabComponentProps extends UIComponentProps
{
    genericTabViewModel: GenericTabViewModel;
    initialTab: string;
    headerTitle: string;
    onTabSelected(): void;
}

export interface GenericTabComponentState extends UIComponentState
{
    selectedTabContent: JSX.Element | boolean;
    selectedTabTitle: string;
}

export interface GenericTabComponentHandler extends UIComponentHandler
{
    onTabSelected(title: string): void;
}

export class GenericTabComponent extends UIComponentImpl<GenericTabComponentProps,
GenericTabComponentState, UIDataModel> implements GenericTabComponentHandler
{
    constructor(props: GenericTabComponentProps)
    {
        super(props);

        let tab = this.props.genericTabViewModel.getTab(props.initialTab);
        this.state = {selectedTabTitle: props.initialTab , selectedTabContent: tab !== undefined ? tab.getTabView() : false};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new GenericTabViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new GenericTabCSSStyleImpl(applicationContext);
    }

    onTabSelected(title: string): void 
    {
        this.props.onTabSelected();
        let tab = this.props.genericTabViewModel.getTab(title);

        this.setState({selectedTabTitle: title , 
            selectedTabContent: tab !== undefined ? tab.getTabView() : false});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/tabs/generictabcomponent.tsx